<template>
    <div class="podcast-selector">
        <podcast-card v-if="podcast"
                      :podcast="podcast"
                      :actions="actions"
                      :open-in-modal="true"/>

        <button v-else class="btn btn-primary"
                type="button"
                @click="browse = true">
            Select DFC Podcast
        </button>

        <podcast-browser-modal v-if="browse"
                               @close="browse = false"
                               @selected="podcastSelected"/>
    </div>
</template>

<script>
import PodcastCard from "@/Components/Podcast/PodcastCard";
import PodcastBrowserModal from "@/Components/Common/PodcastBrowserModal";
export default {
    name: "PodcastSelector",
    components: {PodcastBrowserModal, PodcastCard},
    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            type: Object,
        }
    },

    data(){
        return {
            podcast: null,
            browse: false,

            actions: {
                change: {
                    title: 'Change',
                    class: 'btn-light',
                    action: () => this.browse = true,
                },
                remove: {
                    title: 'Remove',
                    class: 'btn-danger',
                    action: () => {
                        if( !confirm('Remove Podcast?') ) return;
                        this.podcastSelected(null);
                        this.browse = false;
                    },
                }
            }
        }
    },

    methods: {
        podcastSelected(podcast){
            this.podcast = podcast;
            this.$emit('update:modelValue', podcast);
            this.$emit('change', podcast);
        }
    },

    mounted() {
        this.podcast = this.modelValue;
    }

}
</script>

<style scoped>

</style>
